import { NotificationsActions } from '@microsoft/portal-app/lib/Notifications/models';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { TranslationFunction } from 'i18next';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AccountActions } from '../../models';
import { effectLeaveOrgFetch } from '../effects/effectLeaveOrg';
import { LeaveOrgPhase } from '../models';
import { selectLeaveOrgPhase } from '../selectors';

const getLeaveOrgFailureProps = (t: TranslationFunction, name: string) => ({
  title: t('leaveOrgFailureTitle'),
  subText: t('leaveOrgFailureText', { orgName: name }),
  okButtonText: t('Retry'),
  okAction: AccountActions.submitLeaveOrganization,
  cancelAction: AccountActions.cancelLeaveOrganization
});

export const useLeaveOrgFlow = (targetOrg: string, isCurrent: boolean) => {
  const [t] = useLocalization('Account');
  const leaveOrgPhase = useSelector(selectLeaveOrgPhase);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (isCurrent) {
      switch (leaveOrgPhase) {
        case LeaveOrgPhase.hasSubmitLeaveOrg:
          dispatch(effectLeaveOrgFetch());
          break;
        case LeaveOrgPhase.leaveOrgSuccess:
          dispatch({ type: AccountActions.redirectBack });
          break;
        case LeaveOrgPhase.leaveOrgFailure:
          dispatch({ type: NotificationsActions.showDialog, payload: getLeaveOrgFailureProps(t, targetOrg) });
          break;
        default:
      }
    }
  }, [t, isCurrent, targetOrg, leaveOrgPhase, dispatch]);
};
